import warning from 'warning';
export function evaluateProps(backgroundType, customBackground) {
    warning(['light', 'black', 'dark'].includes(backgroundType), 'backgroudType should be from type BackgroundType.');
    if (customBackground) {
        warning(!['light', 'black'].includes(backgroundType), 'customBackground should be passed only if backgroundType is dark.');
    }
}
export const clampParagraph = (paragraph) => {
    if (typeof paragraph === 'string') {
        return paragraph.slice(0, 140);
    }
    return paragraph;
};
